/****************************************************
 * Module Name:  MediaTransferProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class MediaTransferProxy {

    static GetMediaTransferStones = (data, callback) => {
        let params = {
            status: data
        }
        restAPICall(
            Constants.WORKER_URL + "/mediatransfer",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static ForceMediaTransfer = (data, callback) => {
        restAPICall(
            Constants.WORKER_URL + `/mediatransfer`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddStonesToMediaTransfer = (StoneIds, force, callback) => {
        let params = {
            force: force
        }
        restAPICall(
            Constants.MANAGER_URL + `/stone/mediatransfer`,
            "post",
            Constants.userToken,
            params,
            JSON.stringify(StoneIds),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
    static GetMediaTransferStoneWithStatus = (data, callback) => {
        let params = {
            status: data
        }
        restAPICall(
            Constants.MANAGER_URL + `/stone/mediatransfer`,
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}